import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';

import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'delete-modal',
  templateUrl: 'delete-modal.component.html',
  styleUrls: ['delete-modal.component.scss'],
})
export class DeleteModalComponent extends BaseModalComponent {
  updatePublished: boolean = false;

  @Input() title: string;

  @Input() deleteItemName: string;

  @Output() confirm: EventEmitter<any> = new EventEmitter();

  // handlers:
  onConfirmClick(confirm: boolean) {
    this.confirm.emit(confirm);
    this.hide();
  }
}
